module.exports = __webpack_public_path__ + "static/media/ultrasound.8409d398.svg";